<div class="c-nav-bar__left">
    <div class="c-nav-bar__branding">
        <div class="c-nav-bar__brand"></div>
        <div class="c-nav-bar__title"
            innerHTML="{{ 'Navbar.IHD' | translate }}">
            
        </div>
    </div>
    <div class="c-nav-bar__menu">
        <div *ngFor="let menuItem of items"
            class="c-nav-bar__menu-item"
            ihdStateRef
            activeClass="is-active"
            [matchType]="STATE_STARTS_WITH"
            [excludePath]="menuItem.exceptions"
            [state]="menuItem.state"
            (click)="goTo(menuItem.state)">
            {{ menuItem.label | translate }}
        </div>
    </div>
</div>


<div class="c-nav-bar__right">
    <div ihdFeatureCheck [featureId]="FEATURE.BILLING_ALERT">
        <button
            ihdButton
            class="x-nav-bar__btn x-nav-bar__btn--alert"
            ihdAuthenticatedCheck
            [featureId]="FEATURE.BILLING_ALERT"
            *ngIf="billingAlert"
            (click)="viewBilling(false)"
        >
            {{ billingAlert?.badge | translate }}
        </button>
    </div>

    <div class="c-nav-bar__account">
            <button ihdButton
            class="c-btn x-nav-bar__settings"
            ihdStateRef
            activeClass="is-active"
            [matchType]="STATE_STARTS_WITH"
            [excludePath]="[]"
            [state]="DELIVERIES_SETTINGS"
            (click)="goToDeliverySettings()"
            class="x-nav-bar__settings">
            <ihd-icon name="cog" class="c-icon--lg"></ihd-icon>
            {{ 'Navbar.Menu.Settings' | translate }}
        </button>

        <div *ngIf="isDevSupport"
            (click)="goToDevSupport()" 
            class="c-nav-bar__dev-support-avatar"></div>

        <div (click)="toggleDropdown()"
            class="c-nav-bar__account-toggle">
            <ihd-avatar [user]="user" *ngIf="!!user"
                [isSingleInitial]="true"
                [class.c-avatar--admin]="isAdmin"
                [class.c-avatar--manager]="isManager">
            </ihd-avatar>
        </div>
        <ihd-pop [(show)]="showDropdown"
            alignment="right"
            direction="bottom"
            [modal]="true"
            class="x-nav-bar-sub-menu-popover"
            (onBackdropClick)="toggleDropdown()"
            [width]="300"
            [gap]="8"
            [arrow]="false">
    
            <ng-template>
            <ihd-company-selector (onCompanyChangeComplete)="toggleDropdown()"></ihd-company-selector>
                <div class="c-list c-list--xs">

                    <div class="c-list__item">
                        <div (click)="viewMyProfile()" class="c-nav-bar-sub-menu__item">
                            <ihd-icon name="user-rounded" class="c-icon--sm x-nav-bar-sub-menu-item-icon"></ihd-icon>
                            {{ 'Navbar.Menu.MyProfile' | translate }}
                        </div>
                    </div>

                    <ng-container *ngIf="isAdmin || isDevSupport">
                        <div class="c-list__item">
                            <div (click)="viewLocations()" class="c-nav-bar-sub-menu__item">
                                <ihd-icon name="global" class="c-icon--sm x-nav-bar-sub-menu-item-icon"></ihd-icon>
                                {{ 'Navbar.Menu.Locations' | translate }}
                            </div>
                        </div>
                        <div class="c-list__item">
                            <div (click)="viewBilling(true)" class="c-nav-bar-sub-menu__item">
                                <ihd-icon name="card" class="c-icon--sm x-nav-bar-sub-menu-item-icon"></ihd-icon>
                                {{ 'Navbar.Menu.Billing' | translate }}
                            </div>
                        </div>
                    </ng-container>
                    <div class="c-list__item" >
                        <div (click)="launchFeedback()" class="c-nav-bar-sub-menu__item">
                            <ihd-icon name="chat-square-arrow" class="c-icon--sm x-nav-bar-sub-menu-item-icon"></ihd-icon>
                            {{ 'Navbar.Menu.GiveFeedback' | translate }}
                        </div>
                    </div>
                    <div class="c-list__item" >
    
                        <div (click)="logout()" class="c-nav-bar-sub-menu__item">
                            <ihd-icon name="logout" class="c-icon--sm x-nav-bar-sub-menu-item-icon"></ihd-icon>
                            {{ 'Navbar.Menu.LogOut' | translate }}
                        </div>
                        
                    </div>
                </div>
                
            </ng-template>
        </ihd-pop>
    </div>
</div>
